import {Component, inject, input, output, ChangeDetectionStrategy} from "@angular/core"
import {SectionComponent} from "@common/components/item"
import {ToggleComponent} from "@common/components/buttons/toggle/toggle.component"
import {TaskListComponent, TaskListItemType} from "@platform/components/tasks/task-list/task-list.component"
import {TasksService} from "@platform/services/tasks/tasks.service"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-project-management-tasks-section",
    imports: [SectionComponent, ToggleComponent, TaskListComponent],
    templateUrl: "./project-management-tasks-section.component.html",
    styleUrl: "./project-management-tasks-section.component.scss",
})
export class ProjectManagementTasksSectionComponent {
    readonly tasks = inject(TasksService)

    readonly $item = input<TaskListItemType | null | undefined>(null, {alias: "item"})
    readonly onAddNewTask = output<void>()
}
